import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

import { NotificationDto } from './notification.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private http: HttpClient) {}

  public getCustomerSpaceNotifications(customerSpaceId: string): Observable<NotificationDto[]> {
    return this.http.get<NotificationDto[]>(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/notifications`);
  }

  public markNotificationAsRead(customerSpaceId: string, notificationId: string): Observable<NotificationDto[]> {
    return this.http.post<NotificationDto[]>(
      `${environment.apiUrl}/customer-spaces/${customerSpaceId}/notifications/${notificationId}/read`,
      null,
    );
  }

  public markNotificationAsUnread(customerSpaceId: string, notificationId: string): Observable<NotificationDto[]> {
    return this.http.post<NotificationDto[]>(
      `${environment.apiUrl}/customer-spaces/${customerSpaceId}/notifications/${notificationId}/unread`,
      null,
    );
  }

  public markAllNotificationsAsRead(customerSpaceId: string): Observable<NotificationDto[]> {
    return this.http.post<NotificationDto[]>(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/notifications/read`, null);
  }
}
